var map = {
	"./collect.svg": 8802,
	"./denglu.svg": 4589,
	"./dianji.svg": 5279,
	"./duigou.svg": 1517,
	"./gantanhao.svg": 3797,
	"./phone.svg": 4704,
	"./record.svg": 6379,
	"./right.svg": 1722,
	"./search.svg": 9096,
	"./shop.svg": 3032,
	"./shoppingCar.svg": 9962,
	"./shu.svg": 5570,
	"./user.svg": 1077,
	"./xia.svg": 5342,
	"./xing.svg": 5092,
	"./zuojiantou.svg": 3800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5779;